import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '20vh',
        backgroundColor: '#FBBCA9',
        marginBottom: '60px',
        marginTop: '100px',
    }
}))